import { useEffect, useState } from "react";

type ThemePref = "light" | "dark" | "system";

function applyTheme(pref: ThemePref) {
  const root = document.documentElement;
  if (pref === "system") {
    root.removeAttribute("data-theme"); // fall back to @media prefers-color-scheme
  } else {
    root.setAttribute("data-theme", pref);
  }
}

export function useTheme() {
  const [pref, setPref] = useState<ThemePref>(() => {
    const stored = localStorage.getItem("theme");
    return (stored === "light" || stored === "dark") ? stored : "system";
  });

  useEffect(() => {
    applyTheme(pref);
    if (pref === "system") {
      localStorage.removeItem("theme");
    } else {
      localStorage.setItem("theme", pref);
    }
  }, [pref]);

  function toggle() {
    setPref((cur) => {
      if (cur === "system") return "dark";
      if (cur === "dark") return "light";
      return "system";
    });
  }

  return { pref, toggle };
}
